import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import { ICardElementWithChildren } from "backend/model/model";
import React from "react";
import flattenHierarchy from "backend/flattenHierarchy";
import { PerspectiveCard } from "../cards/PerspectiveCard";
import PerspectiveHeader from "../texts/PerspectiveHeader";
import { StackedKpiInitiative } from "../charts/StackedKpiInitiative";
import PerspectiveName from "../texts/PerspectiveName";
import { IChartSelectEvent } from "../charts/types";

const useElementOverviewStackedCardStyles = makeThemedStyles(
  "ElementOverviewStackedCard",
  (theme) => ({
    root: {
      width: "30.4em",
      minHeight: "37.1em",
      fontSize: "10px",
      borderRadius: ".8em",
      border: "1px solid rgba(247, 247, 247, 1)",
    },
    divider: {
      height: "20px",
    },
  })
);

export const ElementOverviewStackedCard = React.memo(
  (
    props: React.PropsWithChildren<{
      element: ICardElementWithChildren;
      periodName: string;
      title: string;
      typenames: string[];
      onSelect?: (value: IChartSelectEvent) => void;
    }>
  ) => {
    const { element: el } = props;
    const styles = useElementOverviewStackedCardStyles();
    return (
      <PerspectiveCard>
        <PerspectiveHeader title={props.title} periodName={props.periodName} />
        <PerspectiveName>{el.name}</PerspectiveName>
        <div className={styles.divider} />
        <StackedKpiInitiative
          element={flattenHierarchy(el.children).filter((ch) =>
            props.typenames.includes(ch.typename)
          )}
          perfColorKey="rangecolor"
          perfNameKey="rangename"
          typenames={props.typenames}
          onSelect={props.onSelect}
        />
      </PerspectiveCard>
    );
  }
);
